import React from 'react'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text'

import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import Badges from 'app/ProfileRevampPage/components/SectionKarya/PelatihanMandiri/Badges'
import ListItem from 'app/ProfileRevampPage/components/SectionKarya/PelatihanMandiri/ListItem'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useLayoutState } from 'app/ProfileRevampPage/hooks/useLayoutState'
import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'
import { delimit } from 'utils/number'
import { getUserDisplayName } from 'utils/user'

const PelatihanMandiriSection = (
  props: React.HTMLAttributes<HTMLDivElement>
) => {
  const { profileData, aksiNyataCount, pelatihanMandiriBadgeCount } =
    useProfile()
  const { hasPelatihanMandiri } = useLayoutState()
  const { SETrackClickEmptyStatePelatihanMandiri } = useSETrackEvent()

  const userDisplayName = getUserDisplayName(profileData?.name ?? '')

  return (
    <div
      className="px-4 py-6 lg:rounded-xl lg:border lg:border-subdued lg:bg-white lg:p-6"
      {...props}
    >
      <div className="flex space-x-2 items-center mb-3">
        <NextImage
          layout="fixed"
          src="/icon/menu-pelatihan-mandiri.svg"
          alt="Pelatihan Mandiri"
          width="24px"
          height="24px"
        />
        <Text variant="heading-md">Pelatihan Mandiri</Text>
      </div>

      {hasPelatihanMandiri ? (
        <>
          <div className="mb-5">
            <div className="bg-gradient-to-br from-[#FFFEEE] to-[#E0F5FF] py-6 px-4 rounded-[4px] text-center">
              <div className="mb-4 flex flex-col items-center">
                <Badges total={pelatihanMandiriBadgeCount} />
              </div>
              <Text variant="body">
                {userDisplayName} sudah menyelesaikan{' '}
                <b>{delimit(pelatihanMandiriBadgeCount)}</b> topik Pelatihan
                Mandiri
              </Text>
            </div>
          </div>

          <div>
            <div className="mb-1">
              <Text variant="subheading">AKSI NYATA</Text>
            </div>

            <div className="mb-3">
              <Text variant="helper" color="subdued">
                Menampilkan {aksiNyataCount} Aksi Nyata terbaru{' '}
                {userDisplayName}
              </Text>
            </div>

            <div className="lg:grid lg:grid-cols-2 lg:gap-4">
              {(profileData?.pelatihanMandiri?.aksiNyata ?? []).map(
                (props, index) => (
                  <ListItem
                    data-testid="profile-aksi-nyata-list-item"
                    key={`profile-aksi-nyata-${index}`}
                    index={index}
                    {...props}
                  />
                )
              )}
            </div>
          </div>
        </>
      ) : (
        <EmptyStateWithAction
          description="Belum ada Pelatihan Mandiri yang Anda selesaikan. Kalau ada, akan muncul di sini."
          imageSrc="/icon/silver-star-badge.png"
          actionText="Ke Pelatihan Mandiri"
          actionPath="/pelatihan-mandiri"
          className="p-3 bg-surface-neutral-subdued rounded-[4px]"
          onActionButtonClicked={SETrackClickEmptyStatePelatihanMandiri}
        />
      )}
    </div>
  )
}

export default PelatihanMandiriSection
